/*eslint-disable*/
import React from "react";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer";
import IndexNavbarLogo from "components/Navbars/IndexNavbarLogo";


export default function Index() {


  return (
    <>
      <IndexNavbar fixed />
<IndexNavbarLogo fixed />
      <section className="relative h-screen">
        {/* Text Above the Video */}
        <div className="absolute bottom-0 font left-0 w-full text-white  xl:text-sm text-center">
          <p className="bg-black w-2/12 flex text-center justify-center ml-auto py-2" style={{ background: '#00000043' }}>
            Power By
            <br>
            </br>
            Fute services
          </p>
        </div>
        <div className="xl:h-screen lg:h-screen md:h-screen h-screen sm:h-auto min-h-screen flex justify-center items-center"
        >
          <iframe src="https://futeservices.in/24-25/IndiaBulls/V4/index.html" style={{ border: "0px", width: "100%", height: "100%" }}></iframe>
          {/* <iframe src="https://futeservices.in/24-25/IndiaBulls/V3/index.html" style={{border: "0px", width:"100%", height:"100%"}}></iframe> */}

        </div>
      </section>


      <div id="ds-sticky-button" className="font xl:text-xl text-white ">
        <a href="/disclaimer" className="rounded">Disclaimer</a>
      </div>
      <Footer className="z-50" />
    </>
  );
}
